import React from 'react'
import { ControlLabel } from '../label/Label'
import DropdownComp from '../dropdown/DropdownComp'
import './labeledDropdown.scss'

const LabeledDropdown = ({
  idLabel,
  required,
  name,
  value,
  optionLabel,
  optionValue,
  idPlaceHolder,
  valueTemplate,
  itemTemplate,
  options,
  onChange,
  onFilter,
  optionDisabled,
  disabled,
  showClear,
  filter,
}) => {
  return (
    <div className="flex-container">
      <ControlLabel id={idLabel} required={required} />
      <div className="control-input">
        <DropdownComp
          value={value}
          valueTemplate={valueTemplate}
          options={options}
          name={name}
          optionLabel={optionLabel}
          optionValue={optionValue}
          optionDisabled={optionDisabled}
          itemTemplate={itemTemplate}
          idPlaceHolder={idPlaceHolder}
          onChange={(e) => onChange(e)}
          onFilter={(e) => onFilter(e)}
          disabled={disabled}
          showClear={showClear}
          filter={filter}
        />
      </div>
    </div>
  )
}

export default LabeledDropdown
